import { batch } from 'react-redux';
import { Dispatch } from 'redux';
import { setActiveLocation } from '~/actions/location';
import { setBookingIsPremium, setBookingStateCode, setLocationId } from '~/actions/newBooking';
import { setCurrentlySelectedLocation } from '~/ducks/currentlySelectedLocation';
import { locationResponseFormatter } from '~/reducers/formatters/location';
import { PositionState } from '~/reducers/position';

export const getState = (position?: PositionState) => {
  const label = position?.result?.label;
  if (!label) return null;

  const split = label.split(',').map((l) => l.trim());
  if (split.length !== 2) return null;

  return split[1];
};

/**
 * Set a new booking location in state, updating all the many relevant areas
 */
export const changeBookingLocation = (stateData: any, dispatch: Dispatch<any>) => {
  const {
    code,
    location,
    location: { id: locationId },
  } = stateData;

  const formatted = locationResponseFormatter(location);

  batch(() => {
    dispatch(setBookingIsPremium(true));
    dispatch(setLocationId(locationId));
    dispatch(setBookingStateCode(code));
    dispatch(setActiveLocation(formatted));
    dispatch(setCurrentlySelectedLocation(formatted));
  });
};
